import chatgrp_list from "../components/chatgrp_list";
import buzz from "../components/microapp_buzz";
import relevant from "../components/relevant";
export default {
  name: 'chat_content',
  components: {chatgrp_list, buzz, relevant},
  data () {
    return {
      title:'Chat grp',
      currentItem: null,
      client_device_height:'',
      myStyles:{}
    }
  },
  mounted(){
    this.client_device_height = this.getClientDeviceHeight;
    this.myStyles = {
      height: `${this.client_device_height}px`,
      'background-color':'#fafafa',
      'overflow-y':'scroll'
    };
  },
  methods: {
  },
  computed: {
    getClientDeviceHeight(){
      return this.$store.getters.getClientDeviceHeight;
    },
    getSearchBar() {
      return this.$store.getters.getSearchBar;
    }
  }

}